import React from 'react'
import './css/HomePageRedBanner.scss'
import { Link } from 'react-router-dom'

function HomePageVodafoneSlider(props: any) {
  return (
    <>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-2 d-flex justify-content-center align-items-center"></div>
          <div className="col-lg-10 d-flex justify-content-center align-items-center">
            <div className="vodafone-logos">
              <Link to="/myspecial/reports/TemlikDetail" target='_blank'><img src="/images/vodafone/temlikdetay.png" alt="Temlik Detay Logo" /></Link>
              <Link to="/myspecial/reports/TemlikTakip" target='_blank'><img src="/images/vodafone/temliktakip.png" alt="Temlik Hesap Logo" /></Link>
              <Link to="/myspecial/reports/provizyon" target='_blank'><img src="/images/vodafone/provizyontakip.png" alt="Provizyon Logo" /></Link>
              <Link to="/myspecial/reports/PKDealer" target='_blank'><img src="/images/vodafone/pkbayi.png" alt="PK Bayi Logo" /></Link>
              <Link to="/myspecial/reports/TemlikSummary" target='_blank'><img src="/images/vodafone/temlikozet.png" alt="Temlik Özet Logo" /></Link>
              <Link to="/myspecial/myorders" target='_blank'><img src="/images/vodafone/kargo.png" alt="Kargo Logo" /></Link>
            </div>
          </div>
        </div>
      </div>
      <br />
    </>
  )
}

export default HomePageVodafoneSlider